var map = {
	"./development": 16175,
	"./development.js": 16175,
	"./production": 75675,
	"./production-next": 71405,
	"./production-next.js": 71405,
	"./production.js": 75675,
	"./staging": 78415,
	"./staging-next": 92585,
	"./staging-next.js": 92585,
	"./staging.js": 78415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 682;